// extracted by mini-css-extract-plugin
export default {"modal":"SavePositionTemplateModal-module__modal__TQbVy","content":"SavePositionTemplateModal-module__content__zDHwR"};